import "./App.css";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";

import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Resources from "./pages/Resources";
import SoftwareDev from "./pages/SoftwareDev";
import Strategy from "./pages/Strategy";
import ArtificialIntelligence from "./pages/ArtificialIntelligence";
import About from "./pages/About";
import Contact from "./pages/Contact";
import AIJourney from "./pages/AIJourney";
import AIDemo from "./pages/AIDemo";
import Capabilities from "./pages/Capabilities";

// Helper component to force page to scroll to top on navigation
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/software-dev" element={<SoftwareDev />} />
        <Route path="/strategy" element={<Strategy />} />
        
        {/* Supporting both cases for AI page safety */}
        <Route path="/artificial-intelligence" element={<ArtificialIntelligence />} />
        <Route path="/ArtificialIntelligence" element={<ArtificialIntelligence />} />
	<Route path="/capabilities" element={<Capabilities />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />

        {/* FIXED: Routes now match the lowercase links in your AI page */}
        <Route path="/ai-journey" element={<AIJourney />} />
        <Route path="/book-demo" element={<AIDemo />} />

        {/* Keeping CamelCase versions as backups */}
        <Route path="/AIJourney" element={<AIJourney />} />
        <Route path="/AIDemo" element={<AIDemo />} />
      </Routes>
    </Router>
  );
}

export default App;